function Loader(props) {
    return (
        <div className="loader"></div>
    );
}

export default Loader;